import { defineMessage } from '@redbubble/next/intl';
import ex14MImg from '../assets/models/ex14_m.png';
import { PreQuerySizeGuideData } from '../types';
import {
  extendedInternationalConversions,
  howToChooseSizeTshirtInstructions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 14
 * Baseball ¾ Sleeve T-Shirt
 * grouse-chips
 * Data source: https://articore.atlassian.net/wiki/spaces/CORE/pages/4748935329/Physical+product+launches+Input+information+required+Vintage+Wash+T-Shirt#Blank-Configuration-(for-use-in-the-PTR-and-Foundry)
 */

export const experience14: PreQuerySizeGuideData = {
  internationalConversions: extendedInternationalConversions,
  fitIndicator: undefined,
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    male: {
      imageUrl: ex14MImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Large. He usually wears a size Large.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 188 cm / 6’2”',
        }),
        defineMessage({
          defaultMessage: 'Waist: 81 cm / 32"',
        }),
      ],
    },
  },
};
